import CrowdfundingBasics, { I18N_CONTEXT } from './crowdfunding_basics'
import { reduxForm } from 'redux-form'
import formUtils from 'lib/form_utils'
import {
  combine,
  required,
  futureDate,
  atMost,
  atLeast,
  length,
} from 'lib/validators'
import { postalCodeValidator } from 'lib/postal_code_validator'
import { endDateValidators, maxDaysValidator } from 'lib/end_date_validators'
import { TITLE_LENGTH } from 'shared/lengths'
import { push } from 'react-router-redux'
import { NEW_CAMPAIGN_ID, setData } from 'redux/modules/campaign'
import { getCampaignSelector } from 'redux/selectors/campaign'
import { getI18n } from 'client/i18n'
import { formatMoney } from 'client/griffin'
import {
  POOLS_CAMPAIGN_TYPES,
  CROWDFUNDING_GOAL_AMOUNT,
  CROWDFUNDING_CAMPAIGN_MAX_DAYS,
} from 'shared/shared_consts'
import { trackClick } from 'lib/fpti_analytics'

const i18n = getI18n(I18N_CONTEXT)
const { MIN_AMOUNT, MAX_AMOUNT } = CROWDFUNDING_GOAL_AMOUNT
const { CROWD_FUNDING } = POOLS_CAMPAIGN_TYPES

let validators = [
  required('goalAmount', i18n('goal_amount_required')),
  required('postalCode', i18n('postal_code_required')),
  required('endDate', i18n('end_date_required')),
  futureDate('endDate', i18n('date_must_be_future')),
  length('poolName', TITLE_LENGTH, i18n('pool_name_too_long')),
  required('poolName', i18n('pool_name_is_required')),
  ...endDateValidators('endDate', i18n('invalid_date')),
  ...postalCodeValidator('postalCode', i18n('postal_code_should_be_valid')),
]

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  const formattedMaxGoalAmount = formatMoney(campaign.currency, MAX_AMOUNT)
  const formattedMinGoalAmount = formatMoney(campaign.currency, MIN_AMOUNT)

  return {
    validate: combine(
      ...validators,
      atMost(
        'goalAmount',
        MAX_AMOUNT,
        i18n('goal_amount_invalid', {
          amount: formattedMaxGoalAmount,
        })
      ),
      atLeast(
        'goalAmount',
        MIN_AMOUNT,
        i18n('goal_amount_invalid_min', {
          amount: formattedMinGoalAmount,
        })
      ),
      maxDaysValidator(
        'endDate',
        new Date(),
        CROWDFUNDING_CAMPAIGN_MAX_DAYS,
        i18n('invalid_date_limit', {
          maxdays: CROWDFUNDING_CAMPAIGN_MAX_DAYS,
        })
      )
    ),
    initialValues: {
      poolName: campaign.title,
      goalAmount: campaign.goal,
      postalCode: campaign.postal_code,
      endDate: campaign.end_date ? new Date(campaign.end_date) : null,
    },
    formattedMaxGoalAmount,
  }
}

const mapDispatchToProps = dispatch => ({
  onSubmit(formValues) {
    trackClick({
      clickName: 'next',
      data: {
        flow: 'crowdfunding',
      },
    })
    dispatch(
      setData(NEW_CAMPAIGN_ID, {
        title: formValues.poolName,
        goal: formValues.goalAmount,
        postal_code: formValues.postalCode,
        end_date: formValues.endDate,
        campaign_type: CROWD_FUNDING,
      })
    )
    dispatch(
      push({
        pathname: `${GLOBAL_CONSTS.REQUEST_URI}/c/create-crowdfunding/story`,
      })
    )
  },
})

export default reduxForm(
  {
    form: 'crowdfunding_basics',
    destroyOnUnmount: false,
    touchOnBlur: true,
    touchOnChange: false,
    fields: ['poolName', 'goalAmount', 'endDate', 'postalCode'],
  },
  mapStateToProps,
  mapDispatchToProps
)(formUtils(CrowdfundingBasics))
